import { Parent } from 'src/app/shared/class/parent.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from './app.reducer';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2'
import { AuthService } from './services/auth.service';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent extends Parent implements OnInit, OnDestroy {

	title = 'sipac';
	nLoadings: number = 0
	subscription: Subscription
	constructor(
		private store: Store<AppState>,
		public authService: AuthService,
		private activatedRoute: ActivatedRoute,
		private router: Router
	) {
		super();
	}

	ngOnInit() {
		// this.subscription = this.store.select("ui").subscribe(state => this.loadingMesage(state.isLoading));
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	/* loadingMesage(isLoading: boolean) {
		if (isLoading) {
			this.nLoadings += 1;
			if (this.nLoadings == 1) {

				Swal.fire({
					title: 'Procesando',
					html: 'Procesando Informacion',
					allowOutsideClick: false,
					onBeforeOpen(){
						Swal.showLoading()
					}
				});
			}
		} else {
			if (this.nLoadings > 0) {
				this.nLoadings--;
			}
			if (this.nLoadings == 0) {
				Swal.close();
			}
		}

	} */
}
